import styled from '@emotion/styled';
import { rem } from '@utils';

const Wrapper = styled.div`
  background: inherit;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${rem(16)};
`;

const FallbackState = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.palette.grey['600']};
  display: flex;
  flex-direction: column;
  gap: ${rem(8)};
  justify-content: center;
  min-height: ${rem(80)};
`;

const ErrorIconWrapper = styled.span`
  background: ${({ theme }) => theme.palette.red['500']};
  border-radius: 50%;
  display: inline-flex;

  svg {
    height: ${rem(16)};
    width: ${rem(16)};
  }
`;

const FallbackText = styled.p`
  font-size: ${rem(14)};
  line-height: ${rem(16)};
`;

export default {
  Wrapper,
  FallbackState,
  ErrorIconWrapper,
  FallbackText
};
